import React from 'react';
import './BeteckningComponent.css';
import Beteckning from './Beteckning';
import { useDataContext } from '../contexts/DataContext';
import styles from './BeteckningarLista.module.css';
import { FeatureUtils } from '../utils/FeatureUtils';

interface BeteckningarListaProps {
  klickaPaBeteckning: (beteckning: string) => void;
  hovraOverBeteckning: (beteckning: string) => void;
  markeraBeteckning: (beteckning: string) => void;
  taBortBeteckning: (beteckning: string) => void;
}

const BeteckningarLista = (props: BeteckningarListaProps) => {
  const { listaBeteckningsObjekt } = useDataContext();

  return (
    <div className={styles.beteckningarListContainer}>
      {listaBeteckningsObjekt.map((listObj: any) => {
        if (listObj.json.type === 'FeatureCollection') {
          if (FeatureUtils.isGodkandDetaljtypInObjektlistCollection(listObj)) {
            return (
              <Beteckning
                beteckning={FeatureUtils.getKommunOchFastighetIFeatureCollection(
                  listObj
                )}
                markerad={listObj.markerad}
                taBort={(bet) => props.taBortBeteckning(bet)}
                hovra={(bet) => props.hovraOverBeteckning(bet)}
                klicka={(bet) => props.klickaPaBeteckning(bet)}
                markera={(bet) => props.markeraBeteckning(bet)}
                objektId={listObj.json.features[0].properties['objekt_id']}
                key={FeatureUtils.getKommunOchFastighetIFeatureCollection(
                  listObj
                )}
              />
            );
          } else if (
            listObj.json.features[0].properties['detaljtyp'] === 'GAANLÄGGN'
          ) {
            return (
              <Beteckning
                beteckning={FeatureUtils.getKommunnamnTraktBlockenhetIFeatureCollection(
                  listObj
                )}
                markerad={listObj.markerad}
                taBort={(bet) => props.taBortBeteckning(bet)}
                hovra={(bet) => props.hovraOverBeteckning(bet)}
                klicka={(bet) => props.klickaPaBeteckning(bet)}
                markera={(bet) => props.markeraBeteckning(bet)}
                objektId={listObj.json.features[0].properties['objekt_id']}
                key={FeatureUtils.getKommunnamnTraktBlockenhetIFeatureCollection(
                  listObj
                )}
              />
            );
          }
        } else if (listObj.json.type === 'Feature') {
          if (FeatureUtils.isGodkandDetaljtypInObjektlista(listObj)) {
            return (
              <Beteckning
                beteckning={FeatureUtils.getKommunOchFastighetFranFeature(
                  listObj
                )}
                markerad={listObj.markerad}
                taBort={(bet) => props.taBortBeteckning(bet)}
                hovra={(bet) => props.hovraOverBeteckning(bet)}
                klicka={(bet) => props.klickaPaBeteckning(bet)}
                markera={(bet) => props.markeraBeteckning(bet)}
                objektId={listObj.json.properties['objekt_id']}
                key={FeatureUtils.getKommunOchFastighetFranFeature(listObj)}
              />
            );
          } else if (listObj.json.properties.detaljtyp === 'GAANLÄGGN') {
            return (
              <Beteckning
                beteckning={FeatureUtils.getKommunnamnTraktBlockenhetFranFeature(
                  listObj
                )}
                markerad={listObj.markerad}
                taBort={(bet) => props.taBortBeteckning(bet)}
                hovra={(bet) => props.hovraOverBeteckning(bet)}
                klicka={(bet) => props.klickaPaBeteckning(bet)}
                markera={(bet) => props.markeraBeteckning(bet)}
                objektId={listObj.json.properties['objekt_id']}
                key={FeatureUtils.getKommunnamnTraktBlockenhetFranFeature(
                  listObj
                )}
              />
            );
          }
        } else {
          return false;
        }
        return false;
      })}
    </div>
  );
};

export default BeteckningarLista;
